export const PAYMENT_NOTES = {
  BUY: 'Each plan will be debited automatically on a monthly/annual basis depending on your subscription choice and can be stopped by switching to freemium',
  SPONSOR:
    'Each view costs $0.2 and will be debited from your credit card at the end of the campaign. You can only sponsor for maximum of 3 months (12 weeks or 90 days)',
};
